import { supabase } from './supabase'

// === MATERIALES ===
// Materiales operativos (NO vendibles): packaging, sellado, oficina, vehículos.
// Distintos de productos (que sí son vendibles).

export async function getMateriales({ incluirInactivos = false, incluirEliminados = false } = {}) {
  let q = supabase
    .from('materiales')
    .select('*')
    .order('categoria')
    .order('sku')
  if (!incluirEliminados) q = q.is('deleted_at', null)
  if (!incluirInactivos) q = q.eq('activo', true)
  const { data, error } = await q
  if (error) { console.error(error); return [] }
  return data || []
}

export async function getMaterialesAlertas() {
  const { data, error } = await supabase
    .from('materiales_alertas')
    .select('*')
  if (error) { console.error(error); return [] }
  return data || []
}

export async function getMovimientos(material_id, limit = 20) {
  const { data, error } = await supabase
    .from('materiales_movimientos')
    .select('*')
    .eq('material_id', material_id)
    .order('created_at', { ascending: false })
    .limit(limit)
  if (error) { console.error(error); return [] }
  return data || []
}

export async function ajustarStock({ sku, tipo, cantidad, motivo, compra_id = null, entrega_id = null }) {
  const { data, error } = await supabase.rpc('materiales_ajustar_stock', {
    p_sku: sku,
    p_tipo: tipo,
    p_cantidad: cantidad,
    p_motivo: motivo,
    p_compra_id: compra_id,
    p_entrega_id: entrega_id,
  })
  if (error) { console.error(error); return { error: error.message } }
  return data
}

export async function crearMaterial(data) {
  const { error } = await supabase.from('materiales').insert(data)
  return { error }
}

export async function actualizarMaterial(id, data) {
  const { error } = await supabase
    .from('materiales')
    .update({ ...data, updated_at: new Date().toISOString() })
    .eq('id', id)
  return { error }
}

export async function eliminarMaterial(id) {
  const { error } = await supabase
    .from('materiales')
    .update({ deleted_at: new Date().toISOString(), activo: false })
    .eq('id', id)
  return { error }
}

// Proveedores que tienen 'materiales' en tipo_suministro (para dropdowns)
export async function getProveedoresMateriales() {
  const { data, error } = await supabase
    .from('proveedores')
    .select('id, nombre, contacto, telefono, tipo_suministro, activo')
    .contains('tipo_suministro', ['materiales'])
    .eq('activo', true)
    .order('nombre')
  if (error) { console.error(error); return [] }
  return data || []
}

export const CATEGORIAS = [
  { value: 'packaging', label: '📦 Packaging' },
  { value: 'sellado', label: '🔥 Sellado' },
  { value: 'limpieza_interna', label: '🧹 Limpieza interna' },
  { value: 'oficina', label: '📎 Oficina' },
  { value: 'vehiculos', label: '🚗 Vehículos' },
  { value: 'otros', label: '📋 Otros' },
]

export const TIPOS_MOVIMIENTO = {
  entrada: { label: 'Entrada', color: '#16a34a', icon: '⬆️' },
  salida: { label: 'Salida', color: '#0284c7', icon: '⬇️' },
  ajuste: { label: 'Ajuste', color: '#9333ea', icon: '🔧' },
  perdida: { label: 'Pérdida', color: '#dc2626', icon: '❌' },
}

export const ESTADOS_STOCK = {
  sin_stock: { label: 'Sin stock', color: '#dc2626', bg: '#fef2f2' },
  bajo: { label: 'Bajo mínimo', color: '#ea580c', bg: '#fff7ed' },
  cercano_minimo: { label: 'Cercano al mínimo', color: '#ca8a04', bg: '#fefce8' },
  ok: { label: 'OK', color: '#16a34a', bg: '#f0fdf4' },
}
